import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useState } from "react";

const links = [
  { to: "/", label: "Home" },
  { to: "/artists", label: "Artists" },
  { to: "/#what-we-do", label: "Services" },
  { to: "/#our-work", label: "Work" },
  { to: "/#contact", label: "Visit" },
];
export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 backdrop-blur-md bg-black/80 border-b border-white/5">
     <div className="max-w-7xl mx-auto px-5 h-16 md:h-20 flex items-center justify-between">
        
        <Link to="/" className="flex items-center gap-3 group">
          <img 
            src="/logo-white.png" 
            alt="VOW Tattoo Logo" 
            className="h-12 md:h-16 w-auto object-contain transition-transform duration-300 group-hover:scale-105"
          />
          <span className="font-bold tracking-[0.2em] text-white text-sm md:text-lg uppercase">
            VOW TATTOO
          </span>
        </Link>

       <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            l.to.includes('#') ? (
              <Link
                key={l.label}
                to={l.to}
                className="text-[13px] tracking-[0.2em] uppercase text-white/70 hover:text-white transition-colors"
              >
                {l.label}
              </Link>
            ) : (
              <NavLink 
                key={l.label} 
                to={l.to} 
                className="text-[13px] tracking-[0.2em] uppercase text-white/70 hover:text-white transition-colors"
              >
                {l.label}
              </NavLink>
            )
          ))}
        </nav>

        <button className="md:hidden text-white p-2" onClick={() => setOpen(!open)}>
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

     {open && (
        <div className="md:hidden bg-black border-t border-white/10 px-6 py-8 flex flex-col gap-5">
          {links.map((l) => (
            l.to.includes('#') ? (
              <Link
                key={l.label}
                to={l.to}
                onClick={() => setOpen(false)}
                className="text-white/90 text-xs tracking-widest uppercase"
              >
                {l.label}
              </Link>
            ) : (
              <Link 
                key={l.label} 
                to={l.to} 
                onClick={() => setOpen(false)} 
                className="text-white/90 text-xs tracking-widest uppercase"
              >
                {l.label}
              </Link>
            )
          ))}
        </div>
      )} 
    </header>
  );
}
